import React from 'react';

import spinner from '../../lib/images/spinner.svg';

export default function Loading({ className, containerClass }) {
  return (
    <div
      className={`flex justify-center ${containerClass}`}
      data-testid="loading"
    >
      <img
        src={spinner}
        alt="loading"
        className={`animate-spin ${className}`}
      />
    </div>
  );
}
